module.exports = __webpack_public_path__ + "static/lolth-symbol-DND3_FnP-bee2ead7008a258a8655c7313a55d685.webp";